export default __webpack_public_path__ + "static/media/17.88d0832d.JPG";